import { IRppTransaction } from './bets.interfaces';
import { LANGS_ENUM } from './enums';
import { WALLET_CODE } from './wallet.interfaces';
export interface IBetSlipAction {
  _id: string;
  action: BETSLIP_ACTION;
  amount?: number;
  action_id?: string;
  createdAt?: number;
  betslip: any;
  ref_transaction_id?: string; // refund
  parent_transaction_id: string; // rollback
}
export interface IBetSlip {
  betslip_id: string;
  actions: IBetSlipAction[];
  status: BETSLIP_STATUS;
  createdAt: number;
  closedAt?: number;
}

export interface ISportsSession {
  _id?: string;
  wallet: WALLET_CODE;
  lang: LANGS_ENUM;
  user_id: string;
  multiplier: number;
  createdAt: number;
  updatedAt?: number;
  amount?: number;
  betslips: IBetSlip[];
  betslipsByFixtures: IBetslipByFixtures[];
  rpp_transaction?: IRppTransaction;
}
export interface IBetslipByFixtures {
  actions: IBetSlipAction[];
  amount: number;
  fixtures: any[];
  provider_betslip_id: string;
}
export enum BETSLIP_STATUS {
  OPEN = 'open',
  SETTLED = 'settled',
  ROLLBACK = 'rollback',
}
export enum BETSLIP_ACTION {
  BET = 'bet',
  WIN = 'win',
  REFUND = 'refund',
  SETTLE = 'settle',
  BALANCE = 'balance',
  ROLLBACK = 'rollback',
}
export interface ISportRequest {
  action: BETSLIP_ACTION;
  currency: WALLET_CODE;
  player_id: string;
  user_id?: string;
  session_id?: string;
}
export interface ISportRequest_bet_win extends ISportRequest {
  amount: number;
  transaction_id: string;
  betslip_id?: string;
  betslip: any;
}
export interface ISportRequest_refund extends ISportRequest {
  amount: number;
  transaction_id: string;
  ref_transaction_id: string;
  betslip_id?: string;
  type: 'default' | 'cash_out';
}
export interface ISportRequest_settle extends ISportRequest {
  betslip_id?: string;
}
export interface ISportRequest_rollback extends ISportRequest {
  amount: number;
  transaction_id: string;
  parent_transaction_id: string;
  betslip_id?: string;
}
export interface ISportResponse {
  balance?: number;
  transaction_id?: string;
  code?: number;
  status?: BETSLIP_STATUS;
}
